/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_ButtonInputs */

const vi_chot_so_button = /** @type {(inputs: Chot_So_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chốt sổ`)
};

/**

* @param {Chot_So_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_button = /** @type {((inputs?: Chot_So_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_button(inputs)
});